// import { useLazyQuery } from '@apollo/client';

import { useLazyQuery } from '@apollo/client';

import { BundleFilterInput } from '@/graphql/contracts/_generated_/contracts';
import { GetPaginatedFilteredBundles, GetPaginatedFilteredBundlesVariables } from 
  '@/graphql/contracts/_generated_/getPaginatedFilteredBundles.query';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';

import GetPaginatedFilteredBundlesQuery from 
  '@/graphql/contracts/getPaginatedFilteredBundles.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

export type PaginatedFilteredBundles = PaginatedFilteredGridData<BundleFilterInput>;

export default function useGetBundles() {
  //const apolloClientContracts = useGetApolloClientContracts();
  const [_getBundles, { loading } ] = useLazyQuery<
  GetPaginatedFilteredBundles,
  GetPaginatedFilteredBundlesVariables
  >(GetPaginatedFilteredBundlesQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'no-cache',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getBundles = async (params: PaginatedFilteredBundles) => {
    const response = await _getBundles({
      variables: {
        ...params,
      } as GetPaginatedFilteredBundlesVariables,
    });
    return response.data?.paginatedFilteredBundles;
  };

  return {
    getBundles,
    isLoadingGetBundles: loading,
  };
}
